<ion-content>
  <div class="brain-body">
    <div class="be-page-content">
      <div class="be-main-card">
        <div class="be-card-content">
          <!-- Game header (timer and score) -->
          <app-bg-header
            *ngIf="showQuestion"
            [isYahootie]=true
            (timeExpire)="timeUpEventHandler()">
          </app-bg-header>

          <!-- Question component -->
          <app-question
            *ngIf="showQuestion"
            [inpQuestions]="questions"
            data-cy='yahootieQuestions'>
          </app-question>

          <!-- Exercise section -->
          <div *ngIf="showExercise" class="exercise-section">
            <h1 class="yahootie-title">Exercises</h1>
            <app-activity
              [activityType]="activityType"
              [content]="exercises"
              [difficulty]="gameConfig?.difficulty">
            </app-activity>
          </div>

          <!-- Leveling screen (completion) -->
          <app-leveling-screen
            *ngIf="leveling"
            [App]="appEnum.Yahootie"
            [Game]="appEnum.Yahootie"
            [score]="score"
            (extraClicked)="showLeaderBoard()"
            (doneClicked)="done()"
            (retryClicked)="retry()">
          </app-leveling-screen>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>